import { render } from "./SkillsMatrix.vue?vue&type=template&id=e6ae2cfe&ts=true"
import script from "./SkillsMatrix.vue?vue&type=script&lang=ts"
export * from "./SkillsMatrix.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__